// +----------------------------------------------------------------------
// | 前端入口：挂载 React + 引入全局样式 + 移除首屏骨架
// +----------------------------------------------------------------------
import { createRoot } from 'react-dom/client';
import App from './App';
import './css/global.less';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

// 挂载完成后移除 index.html 里的 loading 骨架，避免遮挡
const boot = document.getElementById('boot');
if (boot) {
  boot.parentNode.removeChild(boot);
}
